export let OutsideBusinessHoursStatus;
(function (OutsideBusinessHoursStatus) {
  OutsideBusinessHoursStatus["IN_OFFICE_HOURS"] = "IN_OFFICE_HOURS";
  OutsideBusinessHoursStatus["OUT_OF_OFFICE_HOURS"] = "OUT_OF_OFFICE_HOURS";
  OutsideBusinessHoursStatus["INBOX_NOT_FOUND"] = "INBOX_NOT_FOUND";
  OutsideBusinessHoursStatus["NOT_USING_OFFICE_HOURS"] = "NOT_USING_OFFICE_HOURS";
})(OutsideBusinessHoursStatus || (OutsideBusinessHoursStatus = {}));